import axios from "axios";
import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";
const OrderManagementService = {
  getList: async () => {
    const response = await apiService.get(`/${slug}/menuorder`);
    console.log("🚀 ~ getList: ~ response:", response);
    return response.data;
  },

  checkPrintingList: async (tableId) => {
    const response = await apiService.get(
      `/${slug}/printondemand/needs-kot-printing?tableId=${tableId}`
    );
    console.log("🚀 ~ getList: ~ response:", response);
    return response.data;
  },
  postPrint: async (tableId) => {
    try {
      const response = await apiService.post(
        `/${slug}/printondemand/kot-printing-ondemand?tableId=${tableId}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  detail: async (id) => {
    const response = await apiService.get(`/${slug}/menuorder/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/${slug}/menuorder/${id}`);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(
        `/${slug}/menuorder/${id}`,
        updatedData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  cancelTable: async (id, orderStatus) => {
    try {
      const response = await apiService.patch(
        `/${slug}/menuorder/billing/${id}/status?orderStatus=${orderStatus}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error updating cancel order:", error);
      throw error;
    }
  },
  updateStatus: async (id, status, remarks = "") => {
    try {
      const url = `/${slug}/menuorder/${id}/status?orderStatus=${status}`;
      const finalUrl = remarks ? `${url}&remarks=${remarks}` : url;

      const response = await apiService.patch(finalUrl);
      return response.data;
    } catch (error) {
      console.error("Error updating order status:", error);
      throw error;
    }
  },
  // below this comment its for organization POS system order
  addOrder: async (orgCode, orderData) => {
    try {
      const response = await apiService.post(
        `/${slug}/menuorder/billing?orgCode=${orgCode}`,
        orderData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getOrder: async () => {
    const response = await apiService.get(`/${slug}/menuorder/billing`);
    console.log("🚀 ~ getList: ~ response:", response);
    return response.data;
  },
  updateBillingStatus: async (id, status, remarks = "", customerInfo = {}) => {
    try {
      const { name = "", phoneNumber = "", address = "" } = customerInfo;
      let url = `/${slug}/menuorder/billing/${id}/status?orderStatus=${status}`;

      if (remarks) {
        url += `&remarks=${encodeURIComponent(remarks)}`;
      }

      if (name) {
        url += `&Name=${encodeURIComponent(name)}`;
      }
      if (phoneNumber) {
        url += `&PhoneNumber=${encodeURIComponent(phoneNumber)}`;
      }
      if (address) {
        url += `&Address=${encodeURIComponent(address)}`;
      }

      const response = await apiService.patch(url);
      return response.data;
    } catch (error) {
      console.error("Error updating order status:", error);
      throw error;
    }
  },
  deleteOrderItem: async (orderId, menuOrderDetailId) => {
    try {
      const response = await apiService.delete(
        `/${slug}/menuorder/deleteitem/${orderId}?menuOrderDetailId=${menuOrderDetailId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting order item:", error);
      throw error;
    }
  },
  processBillingPayment: async (id, paymentData) => {
    try {
      const {
        addDiscount = 0,
        type,
        remarks = "",
        name = "",
        phoneNumber = "",
        address = "",
      } = paymentData;

      let url = `/${slug}/menuorder/billing/${id}/payment?AddDiscount=${addDiscount}&type=${type}`;

      if (remarks) {
        url += `&remarks=${encodeURIComponent(remarks)}`;
      }
      if (name) {
        url += `&Name=${encodeURIComponent(name)}`;
      }
      if (phoneNumber) {
        url += `&PhoneNumber=${encodeURIComponent(phoneNumber)}`;
      }
      if (address) {
        url += `&Address=${encodeURIComponent(address)}`;
      }

      const response = await apiService.patch(url);
      return response.data;
    } catch (error) {
      console.error("Error processing billing payment:", error);
      throw error;
    }
  },
};

export default OrderManagementService;
